<p>You are being redirected...</p>
<p>Click 
<a
    routerLink="/"
    class="text-sm font-semibold leading-7 text-openflis-600"
>
Back to home</a> to go to the application immediately.</p>